var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("COMMON_EDIT"),
        visible: "",
        width: "55%",
        "custom-class": "site-admin-dialog",
      },
      on: { close: _vm.onCancel },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.initAdInfoLoading,
              expression: "initAdInfoLoading",
            },
          ],
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-width": "150px",
            "label-position": "top",
          },
        },
        [
          !_vm.isArray
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label:
                      _vm.nameFlag === "owner"
                        ? _vm.$t("PAGE_KPMG_TEAM_OWNER")
                        : _vm.$t("FORM_LABEL_siteAdmin"),
                    prop: "adminName",
                  },
                },
                [
                  _c("select-ad", {
                    ref: "selectAdd",
                    attrs: {
                      showAdd: false,
                      api: _vm.selectFromAD,
                      filter: _vm.adFilter,
                      size: "small",
                      collapseTags: false,
                      onChanage: _vm.onAddAccount,
                    },
                    model: {
                      value: _vm.ruleForm.adminName,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "adminName", $$v)
                      },
                      expression: "ruleForm.adminName",
                    },
                  }),
                ],
                1
              )
            : [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("ADD_FORM_LABEL_siteAdmin"),
                      required: "",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "__show-title" },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "select-ad",
                            attrs: {
                              filterable: "",
                              clearable: "",
                              remote: "",
                              placeholder: _vm.$t("searchPlaceholder"),
                              "remote-method": _vm.debounceFn,
                              "value-key": "staffNo",
                              loading: _vm.loading,
                            },
                            model: {
                              value: _vm.currentSelectUser,
                              callback: function ($$v) {
                                _vm.currentSelectUser = $$v
                              },
                              expression: "currentSelectUser",
                            },
                          },
                          _vm._l(_vm.adUserListOpts, function (item) {
                            return _c("el-option", {
                              key: item.userAccount,
                              attrs: {
                                label:
                                  item.userName + "(" + item.profitCenter + ")",
                                value: item,
                              },
                            })
                          }),
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "__add-btn",
                            on: { click: _vm.handleAdd },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-plus",
                              staticStyle: { "margin-right": "2px" },
                            }),
                            _vm._v(
                              "\n                      " +
                                _vm._s(_vm.$t("btn_add")) +
                                "\n                  "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("FORM_LABEL_siteAdminCustom"),
                      prop: "adminName",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "__show-content" },
                      [
                        _c(
                          "transition-group",
                          { staticClass: "__inner", attrs: { name: "fade" } },
                          _vm._l(_vm.siteAdminAdInfoList, function (item) {
                            return _c(
                              "span",
                              { key: item.staffNo, staticClass: "__user-item" },
                              [
                                _vm._v(
                                  "\n                          " +
                                    _vm._s(item.userName) +
                                    "(" +
                                    _vm._s(item.profitCenter) +
                                    ")\n                          "
                                ),
                                _c("i", {
                                  staticClass: "el-icon-delete",
                                  on: {
                                    click: function ($event) {
                                      return _vm.onRemove(item)
                                    },
                                  },
                                }),
                              ]
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ],
        ],
        2
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { staticClass: "cancel-btn", on: { click: _vm.onCancel } },
            [_vm._v(_vm._s(_vm.$t("comment_reSet")))]
          ),
          _c(
            "el-button",
            {
              staticClass: "wl-green",
              attrs: { type: "primary" },
              on: { click: _vm.onConfirm },
            },
            [_vm._v(_vm._s(_vm.$t("btn_save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }